<script setup lang="ts">
import { useCategoriesTileData } from '@bc/discovery/domain/use-category-tile-data';

const { categoriesTileData } = useCategoriesTileData();
</script>

<template>
  <slot :categories-tile-data="categoriesTileData" />
</template>
